import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';

import { FormHelper } from '../../helpers/form-helper';
import { User } from '../../models/user';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent extends FormHelper implements OnInit, OnDestroy {
	private subscriptionManager: Subscription;

  constructor(private authService: AuthService,
							private dialogRef: MdDialogRef<AddUserComponent>,
							private formBuilder: FormBuilder,
							private userService: UserService) {
		super();
		this.subscriptionManager = new Subscription();

		this.buildForm();
	}

	ngOnInit() { }

	ngOnDestroy() {
		this.subscriptionManager.unsubscribe();
	}

	public buildForm(): void {
		this.form = this.formBuilder.group({
			name: new FormControl('', Validators.required),
			lastname: new FormControl('', Validators.required),
			email: new FormControl('', [Validators.required, Validators.email]),
			password: new FormControl('', [Validators.required])
		});
	}

	public async submitForm() {
		const user: User = this.form.value;

		await this.userService.addUser(user);

		this.dialogRef.close();
	}

}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/add-user/add-user.component.ts